import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { first } from 'lodash';

import TemplateButton from './BoardTemplatePickerBodyListingTemplateButton';
import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';
import useAutoSelectTemplate from '../hooks/useAutoSelectTemplate';

import { getTemplateId } from '../boardTemplatePickerUtil';

import { sendAmplitudeEvent } from '../../../analytics/amplitudeService';

import { TemplateCollection } from '../templateTypes';

type Props = {
    className?: string;
    selectedCollectionId: string;
    shouldAutoSelectTemplate: boolean;
    templateCollections: TemplateCollection[];
};

const BoardTemplatePickerCategory = ({
    className,
    selectedCollectionId,
    templateCollections,
    shouldAutoSelectTemplate,
}: Props) => {
    const { templates, selectedTemplateId, selectTemplate } = useContext(boardTemplatePickerContext);

    const selectedCollection = templateCollections.find((category) => category.id === selectedCollectionId);

    const templatesInCollection = (selectedCollection && selectedCollection.templates) || [];

    useAutoSelectTemplate({ enabled: shouldAutoSelectTemplate, fallbackTemplate: first(templatesInCollection) });

    useEffect(
        () =>
            sendAmplitudeEvent({
                eventType: 'Viewed template picker category',
                eventProperties: {
                    category: selectedCollection && selectedCollection.title,
                },
            }),
        [],
    );

    return (
        <div className={classNames('BoardTemplatePickerCategory', 'scrollable', className)} data-scrollable={true}>
            <ul className="picker-templates">
                {templatesInCollection.map((templateEntry) => (
                    <li key={getTemplateId(templateEntry)}>
                        <TemplateButton
                            templateEntry={templateEntry}
                            templates={templates}
                            selectedTemplateId={selectedTemplateId}
                            selectTemplate={selectTemplate}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default BoardTemplatePickerCategory;
